module.exports = __webpack_public_path__ + "static/media/ReallySimpleReferral@2x.26e10d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ReallySimpleReferral@2x.png
// module id = 271
// module chunks = 0